import axios from 'redaxios'
import Swal from 'sweetalert2'
const url = 'https://bodework-backend.herokuapp.com/api/'

export const getAllData = async (endpoint) => {
  try {
    localStorage.setItem('isLoading', JSON.stringify(true))
    let response = await axios.get(`${url}${endpoint}`)
    localStorage.setItem('isLoading', JSON.stringify(false))
    return response.data
  } catch (error) {
    console.error(error)
  }
}

export const getDataById = async (endpoint, body) => {
  try {
    localStorage.setItem('isLoading', JSON.stringify(true))
    let response = await axios.post(`${url}${endpoint}`, body)
    localStorage.setItem('isLoading', JSON.stringify(false))
    return response.data
  } catch (error) {
    console.error(error)
  }
}

export const updateDataById = async (endpoint, body) => {
  try {
    localStorage.setItem('isLoading', JSON.stringify(true))
    let response = await axios.post(`${url}${endpoint}`, body)
    localStorage.setItem('isLoading', JSON.stringify(false))
    return response.data
  } catch (error) {
    console.error(error);
  }
}

export const saveOrUpdateDataById = async (endpoint, body) => {
  try {
    localStorage.setItem('isLoading', JSON.stringify(true))
    let response = await axios.post(`${url}${endpoint}`, body, {
      headers: {
        Accept: 'application/json',
      },
    })
    localStorage.setItem('isLoading', JSON.stringify(false))
    return response.data
  } catch (error) {
    return error.data
  }
}
